/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：ローカルストレージコンフィグ
 *
 * 作成者：2021/11/26 ノア）黄
 * 最終修正者：2021/11/26 ノア）黄
 *
 */

/**
 * ：ローカルストレージコンフィグ
 *
 * @constant
 */
const localStorageConfig: Record<string, string> = {
  baseKey: 'ITP-GeoTracer',
  helpFileName: 'helpFileName', // マニュアルファイル名
  eigyousyoData: 'eigyousyoData' // 選択している営業所データ
}

export default localStorageConfig
